import { useState, useEffect } from "react";

import "./ToDoList.css"

//components
import TodoInput from "./TodoInput";
import TodoList from "./TodoList";
import TodoFilter from "./TodoFilter";
import TodoItem from "./TodoItem";

function TodoApp(){

    const [todos, setTodos] = useState(()=>{
        const saved = localStorage.getItem("todos");
        return saved ? JSON.parse(saved):[];
    });

    const [filter, setFilter] = useState("all");
    //lcoal storage

    useEffect(() =>{
        localStorage.setItem("todos", JSON.stringify(todos));
    }, [todos]);

    function addTodo(text){
        const newToDo = {
            id: Date.now(), //curremt date
            text,
            completed: false
        };
        setTodos([...todos, newToDo]);
    }

    const filteredToDos = todos.filter(todo => {
        if (filter === "completed"){
            return todo.completed;
    
        }
        if (filter === "active"){
            return !todo.completed;
    
        }
        return true;
    });

    function deleteTodo(id){
        setTodos(todos.filter(todo => todo.id !== id));
    }

    function editTodo(id, newText){
        setTodos(
            todos.map(todo => todo.id === id ? { ...todo, text:newText} :todo)
        );
    }

    function toggleComplete(id){
        setTodos(
            todos.map(todo => todo.id === id ? {...todo, completed: !todo.completed} :todo)
        );
    }

    return(
        <div className="TodoApp">
            <h2>To Do List</h2>
            <TodoInput addTodo={addTodo}/>
            <TodoFilter filter={filter} setFilter={setFilter}/>
            <TodoList todos={filteredToDos} deleteTodo={deleteTodo} toggleComplete = {toggleComplete} editTodo={editTodo}/>
        </div>
    )

}
export default TodoApp;